import { useCallback } from 'react';
import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { useExamsList } from './useExamsList';
import { ExamTableColumns } from './ExamTableColumns';
import { CREATE_EXAM } from '../../../shared/Routes';
import {
	hasPrivilege,
	tablePaginationConfiguration,
} from '../../../shared/Utils';
import { useExamModuleIds } from '../../../hooks/useExamModuleIds';
import { FilterExams } from './FilterExams';
import useUserSession from '../../../hooks/useUserSession';
import { PrivilegeCodes } from '../../../shared/RoleConstants';

export const ExamsList = () => {
	const { t } = useTranslation();
	const { navigateWithoutExamModuleIds } = useExamModuleIds();
	const {
		examFilter,
		examsList,
		examsPaging,
		onExamsPageChange,
		onExamsFilterChange,
	} = useExamsList({});
	const { loggedInUserPrivileges } = useUserSession();
	const { exams, pagination } = examsList;
	const tablePaginationConfig = tablePaginationConfiguration(
		examsPaging,
		pagination,
		onExamsPageChange
	);
	const columns = ExamTableColumns();

	const handleCreateExamClick = useCallback(() => {
		navigateWithoutExamModuleIds(CREATE_EXAM);
	}, [navigateWithoutExamModuleIds]);

	const showCreateExam = hasPrivilege(
		PrivilegeCodes.CREATE_EXAM,
		loggedInUserPrivileges
	);

	return (
		<>
			<div className="flex justify-between items-center mb-2.5">
				<h3>{t('examsList')}</h3>
				{showCreateExam && (
					<Button
						className="bg-nav-blue hover:!bg-hover-nav-blue text-white !rounded-none"
						type="primary"
						size="large"
						onClick={handleCreateExamClick}
					>
						{t('createExam')}
					</Button>
				)}
			</div>
			<FilterExams value={examFilter} onFilterChange={onExamsFilterChange} />
			<Table
				dataSource={exams}
				columns={columns}
				pagination={tablePaginationConfig}
				scroll={{ x: 'max-content' }}
				className="overflow-x-auto mt-4"
			/>
		</>
	);
};
